'use strict';


export default function($window) {
	'ngInject';

	return {
		restrict: 'A',
		link: postLink,
		scope: {
			location: '<',
		},
	}

	function postLink(scope, element, attrs) {
		element.on('click', function() {
			var urlBase = 'https://www.google.com/maps/dir/Current+Location/';
			$window.open(urlBase + locationString(scope.location), '_blank');
		});
	}
}


function locationString(l) {
	if (l.street_number && l.route && l.locality && l.administrative_level_1) {
		return `${l.street_number} ${l.route}, ${l.locality}, ${l.administrative_level_1}`;
	}
	if (l.lat && l.lng) {
		return `${l.lat},${l.lng}`;
	}
	return l.raw;
}
